// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton_container__qUCIX","head":"Skeleton_head__LUtc5","icon":"Skeleton_icon__3D0ZG","text":"Skeleton_text__RE75T","content":"Skeleton_content___vuKm"};